import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const ModalDownload = ({
  show,
  handleClose,
  downloadResource,
  href,
  image,
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Body className="text-center my-5">
        <div className="container">
          <h4>Gracias por registrarte</h4>
          <p className="mt-4 mb-5"></p>
          <div className="mb-3">
            <img src={image} alt="Libro" width="240" />
          </div>
          <a
            href={href}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              window.dataLayer.push({
                downloadResource: downloadResource,
              });
              handleClose();
            }}
            className="download-button"
          >
            <Button variant="outline-primary" size="sm">
              Descargar Libro
            </Button>
          </a>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalDownload;
